import { ConsignmentDetails } from 'types';
import { Text } from 'components';
import { formatTimestamp } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface Props {
  consignmentDetails: ConsignmentDetails;
  isShippingFromStore: boolean;
}

export function CollectReceipt({
  consignmentDetails,
  isShippingFromStore,
}: Props) {
  const { code, lastRegistration, customer } = consignmentDetails;
  const { receiverName, receiverCpf, carrier, date } = lastRegistration;

  const { firstName, lastName } = customer;
  const customerName = `${firstName} ${lastName}`;
  const responsible = isShippingFromStore ? carrier : customerName;

  const { hour, minute, formattedDate } = formatTimestamp(date);
  const formattedHour = `${hour}:${minute}`;

  return (
    <S.Main>
      <Text size={FontSize.font12} weight={FontWeight.bold}>
        Comprovante de Retirada
      </Text>

      <Text size={FontSize.font12}>
        Registro de retirada do pedido <strong>{code}</strong>, realizado em{' '}
        <strong>{formattedDate}</strong> às <strong>{formattedHour}</strong> por{' '}
        <strong>{receiverName}</strong>, CPF <strong>{receiverCpf}</strong>, em
        nome de <strong>{responsible}</strong>.
      </Text>

      <S.Wrapper>
        <Text size={FontSize.font12}>{receiverName}</Text>
      </S.Wrapper>
    </S.Main>
  );
}
